import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import './ui/styles.css';
// Importado pelo efeito colateral: Chrome dispara `beforeinstallprompt` uma
// vez e cedo, antes de a árvore existir, e quem não estiver ouvindo perde.
import './lib/install';
import { markNativeSignIn } from './lib/native';
import { listen } from './lib/diagnose';

// Antes de tudo: o que a página se queixar a caminho do provedor tem de
// ser recolhido desde a primeira linha, não a partir do primeiro render.
listen();

// Antes do primeiro render: a marca precisa sobreviver à ida ao Google, e
// a query some no caminho.
markNativeSignIn();

/**
 * The app lives at okazip.com now. Anyone still holding a wcloud-508914.web.app
 * link — and the first people to try this all are — gets sent across rather
 * than finding a dead page or, worse, a working one whose passkeys no longer
 * match the relying party.
 *
 * Before anything else runs: no Service Worker registration, no session read,
 * on a host we are leaving.
 */
const HOME = 'okazip.com';
const LEGACY = /^wcloud-508914\.(web\.app|firebaseapp\.com)$/;
if (LEGACY.test(location.hostname)) {
  location.replace(`https://${HOME}${location.pathname}${location.search}${location.hash}`);
}

// The Service Worker is how encrypted media reaches an <img> tag. Without it
// the app still runs; media just will not render.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js', { type: 'module', scope: '/' })
    // Check for a newer worker on every load, so a deploy reaches a browser
    // that already has one instead of waiting for every tab to close.
    .then((reg) => reg.update().catch(() => {}))
    .catch((e) => console.warn('media service worker unavailable:', e));
}

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>,
);
